// extracted by mini-css-extract-plugin
export var phone = "_4l-0";
export var phoneDragging = "_4l-1";